import classNames from 'classnames';
import React, { FC } from 'react';

export interface LoaderProps {
  className?: string;
  embedInParent?: boolean;
}

const Loader: FC<LoaderProps> = ({ className, embedInParent = false }) => {
  return (
    <div
      className={classNames(
        'z-[100] grid place-items-center bg-greyBase04',
        embedInParent ? 'absolute inset-0 h-full w-full' : 'fixed inset-0',
        className,
      )}
    >
      <svg
        className="h-[100px] w-[100px] shrink-0"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 200 200"
        aria-hidden
      >
        <linearGradient id="a9">
          <stop offset="0" stopColor="#C00000" stopOpacity="0"></stop>
          <stop offset="1" stopColor="#C00000"></stop>
        </linearGradient>
        <circle
          fill="none"
          stroke="url(#a9)"
          strokeWidth="26"
          strokeLinecap="round"
          strokeDasharray="0 44 0 44 0 44 0 44 0 360"
          cx="100"
          cy="100"
          r="70"
        >
          <animateTransform
            type="rotate"
            attributeName="transform"
            additive="replace"
            calcMode="discrete"
            dur="0.7"
            values="360 100 100;324 100 100;288 100 100;252 100 100;216 100 100;180 100 100;144 100 100;108 100 100;72 100 100;36 100 100"
            repeatCount="indefinite"
          />
        </circle>
      </svg>
    </div>
  );
};

export default Loader;
